import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0, -2),
    },
  },
}))

export default useStyles
